import {
	Component,
	ojs,
	state,
	app,
	each,
	payload,
} from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import {
	cleanDispose,
	empty,
	either,
	showActionButton,
	isMobile,
	eParse,
} from "../../helpers";
import { api } from "../../declarations";
import { routes } from "../../backendRoutes";

import LogisticsCompanyCanvas from "../Offcanvas/LogisticsCompanyCanvas";
import LogisticsCompanyModal from "../Modals/LogisticsCompanyModal";
import LogisticsCompanyView from "../Views/LogisticsCompanyView";

const h = app("h");
const uc = app("uc");
const broker = app("broker");
const $e = app("$e");

ojs(LogisticsCompanyCanvas, LogisticsCompanyModal, LogisticsCompanyView);

export default class LogisticsCompanyForm extends Component {
	holder = null;
	button = null;
	company = null;
	companies = state([]);

	render(companiesState, ...args) {
		let companies = companiesState.value;

		return h.div(
			{
				class: "d-flex gap-3 flex-column mb-3",
				id: "lcf-companies-holder",
			},
			either(
				empty(companies),
				() => h.Spinner(),
				each(companies, (c) =>
					h.LogisticsCompanyView(c, {
						vehicleListeners: {
							listeners: {
								click: () =>
									this.selectCompany(
										c,
										dom.get(`[hook='lcv-${c.id}']`)
									),
							},
						},
						bodyListeners: {
							listeners: {
								click: () => {
									const holder = dom.get(
										`[hook='lcv-${c.id}']`
									);

									uc.fleetType.value =
										holder?.getAttribute(
											"lcv-active-fleet"
										) ?? "bicycle";

									this.selectCompany(c, holder);
								},
							},
						},
					})
				)
			),
			h.div(
				{
					class: "d-flex justify-content-between gap-3 fs-4",
					style: "margin-top: 6rem;",
				},
				h.button(
					{
						class: "btn btn-outline-danger border-0 w-100",
						onclick: this.method("closeForm"),
					},
					"Cancel"
				)
			),
			...args
		);
	}

	async getOptions(addressId, type = "normal", errandId = null) {
		let parent = dom.id("lcf-companies-holder");

		let res = false;

		if (type == "errand") {
			res = await api.get(`${routes.errands}/${errandId}/delivery-price`);
		} else {
			res = await api.get(
				`${routes.orders}/delivery-price/d/${addressId}`
			);
		}

		if (!res) {
			h.span(
				{ parent, resetParent: true, class: "text-secondary" },
				"Could not load Companies. Please try again"
			);
			return;
		} else if (empty(res.data.companies)) {
			h.span(
				{ parent, resetParent: true, class: "text-secondary" },
				"No deliverer was found online in this area at the moment. Please try again later."
			);
			return;
		}

		let companies = Object.values(res.data.companies);

		companies.sort((cA, cB) => {
			if (cA.rating == cB.rating) {
				const cAFee =
					Object.values(cA.delivery_fee_per_vehicle)[0] ?? null;
				const cBFee =
					Object.values(cB.delivery_fee_per_vehicle)[0] ?? null;

				if (empty(cAFee) || empty(cBFee)) return 0;

				return cAFee - cBFee;
			} else return cA.rating - cB.rating;
		});

		this.companies.value = companies;

		let firstCompany = companies[0];
		let firstFleet = Object.keys(firstCompany.delivery_fee_per_vehicle)[0];

		setTimeout(() => {
			try {
				uc.fleetType.value = firstFleet;

				this.selectCompany(
					firstCompany,
					dom.get(`[hook="lcv-${firstCompany?.id}"]`)
				);
			} catch (e) {}
		}, 1000);
	}

	$$logisticsCompany = {
		needs: {
			form: (ed, event) => this.showForm(ed, event),
		},
	};

	async showForm(ed, event) {
		if (this.holder) {
			cleanDispose(this.holder);
		}

		let data = eParse(ed);
		const addressId = data.message.get("addressId", 0);
		const orderType = data.message.get("type", "normal");
		const errandId = data.message.get("errandId", 0);

		if (isMobile()) {
			this.holder = tool.offcanvas(
				h.LogisticsCompanyCanvas(
					h.LogisticsCompanyForm(this.companies)
				),
				h.h5({ class: "text-center pt-3" }, "Select Delivery Company"),
				"bottom",
				{ style: "min-height: auto; max-height: calc(100% - 25vh)" }
			);
			this.holder._element?.addEventListener(
				"hide.bs.offcanvas",
				() => (this.companies.value = [])
			);
		} else {
			this.holder = tool.plainModal(
				h.LogisticsCompanyModal(h.LogisticsCompanyForm(this.companies))
			);

			this.holder._element?.addEventListener(
				"hide.bs.modal",
				() => (this.companies.value = [])
			);
		}
		this.holder.show();
		this.getOptions(addressId, orderType, errandId);
	}

	closeForm() {
		this.holder.hide();
	}

	selectCompany(company, elem) {
		if (this.company) {
			dom.get(`[hook="lcv-${this.company.id}"]`)?.classList.remove(
				"border-dark"
			);
		}

		this.company = company;
		elem.classList.add("border-dark");

		showActionButton(
			(ActionForm, callbackId) => {
				ActionForm.closeForm();
				this.closeForm();
				uc.logisticsCompany.value = tool.deepCopy(this.company);
				broker.send(
					$e.logisticsCompany.is.selected,
					payload({ company: this.company })
				);
				this.company = null;
				this.companies.value = [];
			},
			"Choose Company",
			true
		);
	}
}

ojs(LogisticsCompanyForm);
